import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { IstStudyReportsViewModalComponent } from './ist-study-reports-view-modal/ist-study-reports-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-ist-study-reports',
  templateUrl: './ist-study-reports.component.html',
  styleUrls: ['./ist-study-reports.component.scss']
})
export class IstStudyReportsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  ApplicationID: string;
  studyreportsform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  staticformFields: any;
  typeOptions: any[] = [];
  StartDateO: DateObject
  EndDateO: DateObject;
  screenName:string = "";
  collapesedOrNot:boolean = false;
  constructor(
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe,

  ) {
  }

  ngOnInit() {

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
     this.studyreportsform = new UntypedFormGroup({
      Type: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      PatientName: new UntypedFormControl(null),
      SubmittedDateFrom: new UntypedFormControl(null),
      SubmittedDateTo: new UntypedFormControl(null),
      EndDateO : new UntypedFormControl(null),
      StartDateO : new UntypedFormControl(null)

    });
    this.permission = this.commonService.getPagePermission("IST09").toLowerCase();

    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("IST09").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
            this.GetSummaryData();
          clearInterval(intervalId);
        }
      }, 1000);
    }
    else {
      this.GetSummaryData();
    }

  
    this.getStaticFiledsData('SCR-009');
    this.GetScreenConfigControls('SCR-009');
    
    this.userType = this.userService.getUserType();
    
 
   
   
    // this.tempoperations = [
    // ];
   
    this.GetDropDownsData();

  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if (this.userType == "E") {
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.TYPE.LABEL_NAME,
              "field": "Type",
              "tooltipField": "Type"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title",
              "tooltipField": "Title"
            },      
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr",
              "tooltipField": "Submitted Date"
            },
            {
              "headerName": "Status",
              "field": "Status",
              "tooltipField": "Status"
            }
          ];
        } else {
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.TYPE.LABEL_NAME,
              "field": "Type",
              "tooltipField": "Type"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title",
              "tooltipField": "Title"
            },
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr",
              "tooltipField": "Submitted Date"
            }
          ];
        }
      });
  }

  GetDropDownsData() {
    this.summaryService.masterData("api/ISTStudyreports/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=").subscribe(summary => {
      this.typeOptions = summary["MasterData1"];
      this.typeOptions = [{ label: "All", value: "", checked: true }].concat(this.typeOptions);
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  // onRowDoubleClicked(event) {
  //   this.modalService.show(IstStudyReportsViewModalComponent, {
  //     backdrop: false,
  //     keyboard: false,
  //     ignoreBackdropClick: true,
  //     class: 'modal-llg modal-full-height modal-right',
  //     animated: true,
  //     data: {
  //       heading: 'View',
  //       content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
  //     }
  //   });
  // }

  add() {
    let modalRef = this.modalService.open(IstStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.GetSummaryData();
    })
  }

  edit(RcordData:any) {
    let modalRef = this['self'].modalService.open(IstStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: "Edit",
      content: { id: RcordData['ID'], ApplicationID: RcordData.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  view(RcordData:any) {
    let modalRef = this['self'].modalService.open(IstStudyReportsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: "View",
      content: { id: RcordData['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].GetSummaryData();
    })
  }

  delete(RcordData:any) {

    // if (this['self'].userType == "E") {
    if (RcordData['SubmittedDateStr'] == null || RcordData['SubmittedDateStr'] == undefined || RcordData['SubmittedDateStr'] == "") {
      let id = RcordData['ID'];
      let stdyReport = RcordData['Title'];
      const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
      modalRef.componentInstance.Content = { heading: 'Delete Study Report', custommessage: 'Are you sure you want to delete '   + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" }
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.DeleteRecord('api/ISTStudyreports/Delete?RecordID=' + id).subscribe(summary => {

            if (summary["Status"] == 0) {
              // toastrService.success("Selected Record(s) has been Deleted");
              this['self'].commonService.SuccessBanner(this['self'].screenName +' deleted successfully');
              this['self'].GetSummaryData();
            }
            else {
              this['self'].commonService.ValidationBanner("Referenced record Can't be Deleted");

            }
          });
        }
      });

      // }
      // else {
      //   this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be deleted." } } });
      // }
    }
    else {
      this.commonService.ValidationBanner("Record Can't be deleted");
      // this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be deleted." } } });
    }
  }

  GetSummaryData() {

    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTStudyreports/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  getSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/ISTStudyreports/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    this.tempoperations = [];
    if (this.permission == "new") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add " + this.screenName,
          "id": "add"
        }
      ];
    }

    if (this.permission == "edit") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        }
      ];
    }

    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if (element.Status == "Submitted") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        if (this.permission == "new") {
          tempoperations2.push({
            "name": "Add  " + this.screenName,
            "id": "add"
          })
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.Status == "Drafted") {
        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.permission == "view") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }
    });

    setTimeout(()=>{
      this.gridApi.sizeColumnsToFit();
      },500);
    return RawData;
  }

  setDef(parmoperations: any): any {
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }


  SearchClear() {
    this.studyreportsform.reset();
    //  this.setSummary();
  }

  AdvanceSearch() {
    var formData = this.studyreportsform.value;
    // if (!this.validateSearch()) {
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["SubmittedDateFrom"] != null && formData["SubmittedDateFrom"] != "" && formData["SubmittedDateFrom"] != 'Invalid Date') {
      formData["StartDateStr"] = this.datepipe.transform(formData["SubmittedDateFrom"], 'dd-MMM-yyyy');
      formData["StartDateO"] = this.Full_Start_Date;
    }
    if (formData["SubmittedDateTo"] != null && formData["SubmittedDateTo"] != "" && formData["SubmittedDateTo"] != 'Invalid Date') {
      formData["EndDateStr"] = this.datepipe.transform(formData["SubmittedDateTo"], 'dd-MMM-yyyy');
      formData["EndDateO"] = this.Full_End_Date;
    }
    formData["SubmittedDateFrom"] = null;
    formData["SubmittedDateTo"] = null;
    this.getSummarySearch(formData);
    // } else {
    //   this.commonService.ValidationBanner("Please enter at least one criteria to perform search" );
    //   // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: "Please enter at least one criteria to perform search" } } });

    // }
  }

  onAdvanceSearchOperation(searchFiletrs) {

  }


  validateSearch() {
    let hasValue: Boolean = true;
    if (this.studyreportsform.controls["SubmittedDateTo"].value != null && this.studyreportsform.controls["SubmittedDateTo"].value != undefined && this.studyreportsform.controls["SubmittedDateTo"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.studyreportsform.controls["SubmittedDateFrom"].value != null && this.studyreportsform.controls["SubmittedDateFrom"].value != undefined && this.studyreportsform.controls["SubmittedDateFrom"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.studyreportsform.controls["Type"].value != null && this.studyreportsform.controls["Type"].value != undefined && this.studyreportsform.controls["Type"].value != "") {
      hasValue = false;
    }

    if (this.studyreportsform.controls["Title"].value != null && this.studyreportsform.controls["Title"].value != undefined && this.studyreportsform.controls["Title"].value != "") {
      hasValue = false;
    }
    return hasValue;
  }
  onRowDoubleClicked($event)
  {

  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID,'', (ScreenData) => {
      this.screenName = ScreenData.NAME;
      this.GetSummaryData();
    });
  }
}
